import React, { useEffect, useState } from 'react';
import { Redirect, BrowserRouter, Route, Switch } from 'react-router-dom';

import Login from 'modules/Granel/pages/Login';
import { useAuth } from 'hooks/authHook';
import Profile from 'pages/Profile';
import AddContract from 'pages/AddContract';
import BankSlip from 'pages/BankSlip';
import Cadastro from 'modules/Granel/pages/cadastro';
import NewCadastro from 'modules/Granel/pages/NewCadastro';
import ConfirmacaoEmail from 'modules/Granel/pages/confirmacao';
import Endereco from 'modules/Granel/pages/endereco';
import EsqueciSenha from 'modules/Granel/pages/esqueci-senha';
import Contato from 'modules/Granel/pages/fale-conosco';
import NewRefuel from 'pages/NewRefuel';
import BestTimes from 'pages/BestTimes';
import NewManutencao from 'modules/Granel/pages/new-manutencao';
import TechnicalDocumentation from 'modules/Granel/pages/documentacao';
import TechnicalDocumentationOs from 'modules/Granel/pages/documentacao-os';
import NewNotas from 'modules/Granel/pages/new-notas';
import NewPortal from 'pages/Portal';
import TrackingRefuel from 'pages/TrackingRefuel';
import BusinessContact from 'pages/BusinessContact';
import PerguntasFrequentes from 'modules/Granel/pages/perguntas-frequentes';
import DicasSeguranca from 'modules/Granel/pages/dicas-seguranca';
import MFARegister from 'modules/Granel/pages/MFARegister';

const Routes = () => {
  const { userData } = useAuth();

  const PublicRoutes = [
    { path: '/', Component: Login },
    { path: '/acessar', Component: Login },
    { path: '/validar-token', Component: MFARegister },
    { path: '/endereco', Component: Endereco },
    { path: '/confirmacao', Component: ConfirmacaoEmail },
    { path: '/primeiro-acesso-granel', Component: Cadastro },
    { path: '/novo-primeiro-acesso-granel', Component: NewCadastro },
    { path: '/esqueci-senha', Component: EsqueciSenha },
    { path: '/redefinir-senha', Component: EsqueciSenha },
  ];

  const GranelRoutes = [
    { path: '/portal', Component: NewPortal },
    { path: '/boletos', Component: BankSlip },
    { path: '/notas', Component: NewNotas },
    { path: '/manutencao', Component: NewManutencao },
    { path: '/documentacao', Component: TechnicalDocumentation },
    { path: '/documentacao-os', Component: TechnicalDocumentationOs },
    { path: '/pedido-abastecimento', Component: NewRefuel },
    { path: '/tracking', Component: TrackingRefuel },
    { path: '/melhores-horarios', Component: BestTimes },
    { path: '/fale-conosco', Component: Contato },
    { path: '/dicas-seguranca', Component: DicasSeguranca },
    { path: '/perguntas-frequentes', Component: PerguntasFrequentes },
    { path: '/perfil', Component: Profile },
    { path: '/nova-empresa', Component: AddContract },
    { path: '/atendimento-comercial', Component: BusinessContact },
  ];

  const buildRoutes = (hasAccessToken, hasRefreshToken) => {
    let initalRoute = [];
    if (hasAccessToken && hasRefreshToken) {
      initalRoute = [...PublicRoutes, ...GranelRoutes];
    } else {
      initalRoute = PublicRoutes;
    }
    return initalRoute;
  };

  const [routes, setRoutes] = useState();

  useEffect(() => {
    const hasAccessToken =
      userData.accessToken ||
      localStorage.getItem('@UltragazEmpresarial:accessToken');
    const hasRefreshToken =
      userData.refreshToken ||
      localStorage.getItem('@UltragazEmpresarial:refreshToken');

    setRoutes(buildRoutes(hasAccessToken, hasRefreshToken));
  }, [userData, setRoutes]);

  const moreProps = (path, Component, props) => {
    switch (path) {
      case '/redefinir-senha':
        return <Component {...props} step={3} />;
      default:
        return <Component {...props} />;
    }
  };

  if (!routes) return null;

  return (
    <BrowserRouter>
      <Switch>
        {routes.map(({ Component, ...route }) => (
          <Route
            exact
            key={route.path}
            path={route.path}
            render={(props) => moreProps(route.path, Component, props)}
          />
        ))}
        <Redirect from="*" to="/" />
      </Switch>
    </BrowserRouter>
  );
};

export default Routes;
